var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "add-function" },
    [
      _c(
        "sdz-modal",
        {
          ref: "sdzModalRef",
          attrs: {
            cancelEvent: "cancel",
            width: "450",
            title: "Adicionar função",
            "buttons-position": "right",
            "confirm-button-label": "Adicionar",
          },
          on: {
            confirm: _vm.onConfirm,
            close: _vm.close,
            cancel: _vm.onCancel,
          },
        },
        [
          _c(
            "div",
            { staticClass: "add-function-content" },
            [
              _c("AppCheckBox", {
                attrs: {
                  "on-value": "fields",
                  "on-text": "function",
                  options: _vm.options,
                },
                model: {
                  value: _vm.functionOptions,
                  callback: function ($$v) {
                    _vm.functionOptions = $$v
                  },
                  expression: "functionOptions",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }